import { FC, useCallback, useMemo } from "react";
import {
  connectRefinementList,
  RefinementListProvided,
} from "react-instantsearch-core";
import { Box } from "@otrium/core";
import { Trans } from "@lingui/macro";
import { orderBy } from "lodash-es";
import { Checkbox } from "src/atoms/Checkbox";
import { useFilterApplied } from "src/organisms/AlgoliaProductList/useFilterApplied";
import {
  RateLabelWrapper,
  GoodOnYouLabel,
} from "src/organisms/AlgoliaProductList/DesktopFilterVeiw/ConsciousRefinementList/ConsciousFilter.styled";
import FaceContentIcon from "src/icons/FaceContentIcon";
import FaceSmileIcon from "src/icons/FaceSmileIcon";
import FaceHappyIcon from "src/icons/FaceHappyIcon";

const GoodOnYouFilterComponent: FC<RefinementListProvided> = ({
  items,
  refine,
}) => {
  const sortedItems = useMemo(() => orderBy(items, "label", "desc"), [items]);
  const { handleRefine } = useFilterApplied(sortedItems, refine);
  const isEveryItemSelected = useMemo(
    () => sortedItems.every((item) => item.isRefined),
    [sortedItems]
  );

  const toggleSelectAll = useCallback(() => {
    const itemsToRefine = isEveryItemSelected
      ? []
      : sortedItems.reduce((previousValue, currentValue) => {
          previousValue.push(currentValue.label);
          return previousValue;
        }, [] as string[]);
    handleRefine(itemsToRefine)();
  }, [handleRefine, isEveryItemSelected, sortedItems]);

  return (
    <Box data-testid="good-on-you-filter-mobile">
      <Box bg="tone.sand" py={[4, 4, 3]} pl={3} ml={[0, 0, 0, "-16px"]}>
        <Checkbox checked={isEveryItemSelected} onChange={toggleSelectAll}>
          <span data-testid="conscious-filter-select-all">
            <Trans>Select all</Trans>
          </span>
        </Checkbox>
      </Box>
      <Box>
        <Box
          as="ul"
          sx={{
            listStyle: "none",
          }}
        >
          {sortedItems?.map((item, i) => {
            const label = item.label.split("||");
            const labelRate = label[0];
            const labelName = label[1];
            return (
              <Box as="li" key={`good-on-you-filter-item-${i}`} p={3}>
                <Checkbox
                  checked={item.isRefined}
                  onChange={handleRefine(item.value)}
                >
                  <RateLabelWrapper>
                    {labelRate === "3" && (
                      <FaceContentIcon width={16} height={16} stroke="black" />
                    )}
                    {labelRate === "4" && (
                      <FaceSmileIcon width={16} height={16} stroke="black" />
                    )}
                    {labelRate === "5" && (
                      <FaceHappyIcon width={16} height={16} stroke="black" />
                    )}
                    {labelRate}/5 {labelName}
                  </RateLabelWrapper>
                </Checkbox>
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box
        sx={{
          padding: "16px 16px 0",
          position: "absolute",
          bottom: "80px",
        }}
      >
        <GoodOnYouLabel>
          <Trans>Provided by Good On You</Trans>®.{" "}
          <a
            data-testid="good-on-you-link"
            href={`http://howwerateourbrands.otrium.com/`}
          >
            <Trans>Learn how this is rated</Trans>
          </a>
        </GoodOnYouLabel>
      </Box>
    </Box>
  );
};

const GoodOnYouFilter = connectRefinementList(GoodOnYouFilterComponent);

export default GoodOnYouFilter;
